export const SERVICES = [
  { num: "01", title: "AI & Machine Learning", desc: "LLM integrations, RAG pipelines, predictive modeling, and computer vision deployed at scale.", tags: ["LLMs", "RAG", "Vision", "MLOps"] },
  { num: "02", title: "Enterprise Software", desc: "High-performance distributed systems built for throughput, observability, and security.", tags: ["Go", "Rust", "K8s", "Postgres"] },
  { num: "03", title: "Digital Product Design", desc: "Award-winning UI/UX with brutalist clarity, motion-first prototypes, and design systems.", tags: ["UX", "Systems", "Motion", "Prototype"] },
  { num: "04", title: "Cloud & DevOps", desc: "Zero-downtime infra, multi-region architectures, and developer platforms that scale teams.", tags: ["AWS", "GCP", "Terraform", "CI/CD"] },
  { num: "05", title: "Mobile Engineering", desc: "Native and cross-platform applications with pixel-perfect motion and offline-first data.", tags: ["Swift", "Kotlin", "RN", "Flutter"] },
];

export const PROJECTS = [
  {
    client: "VaultX", industry: "Fintech", year: "2025",
    problem: "Institutional crypto traders needed millisecond-latency dark-pool execution.",
    solution: "Rust backend, WebGL-accelerated React dashboard, FIX gateway.",
    metric: "40%", metricLabel: "latency reduction",
    side: "$2B+ daily notional",
    stack: ["React", "WebGL", "Rust", "Go"],
    image: "https://images.unsplash.com/photo-1773349807434-374473797148?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "Praana Health", industry: "Healthtech", year: "2024",
    problem: "Fragmented wearable data blocked holistic diagnosis.",
    solution: "AI aggregator pulling 12+ APIs into one diagnostic canvas.",
    metric: "400+", metricLabel: "clinics onboarded",
    side: "APAC rollout in 9 months",
    stack: ["Python", "TensorFlow", "React Native", "AWS"],
    image: "https://images.unsplash.com/photo-1720135885007-454165745e21?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "Aura Commerce", industry: "E-commerce", year: "2024",
    problem: "Luxury storefronts bleeding conversions on mobile web.",
    solution: "Headless commerce, predictive search, motion-led checkout.",
    metric: "125%", metricLabel: "mobile conversion lift",
    side: "INR 180Cr GMV added",
    stack: ["Next.js", "Shopify Plus", "Framer Motion"],
    image: "https://images.unsplash.com/photo-1656231267330-f605c1c16a57?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "Nexus Supply", industry: "Logistics", year: "2025",
    problem: "Static routing models ignored weather, port congestion, fuel.",
    solution: "Predictive routing AI with live port & weather overlays.",
    metric: "$14M", metricLabel: "annual savings",
    side: "17% emission drop",
    stack: ["Python", "D3.js", "PostgreSQL"],
    image: "https://images.unsplash.com/photo-1767817099805-d79e31fb968c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "DataNode", industry: "DevTools SaaS", year: "2025",
    problem: "Data pipelines were impossible to reason about visually.",
    solution: "Node-based programming canvas with real-time collaboration.",
    metric: "50k+", metricLabel: "developers in 6 months",
    side: "$6.2M ARR run-rate",
    stack: ["React Flow", "Zustand", "Node.js"],
    image: "https://images.unsplash.com/photo-1759159347827-de3a54002de7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "CineStream", industry: "Media OTT", year: "2024",
    problem: "Legacy streaming client choked on 4K delivery across India tier-2/3.",
    solution: "Client rewrite, edge caching at Cloudflare, adaptive bitrate.",
    metric: "99.99%", metricLabel: "uptime achieved",
    side: "60fps UI on low-end Android",
    stack: ["React", "Cloudflare", "GraphQL"],
    image: "https://images.unsplash.com/photo-1771873680097-7506773a2b02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export const STATS = [
  { k: "84", label: "Products Shipped" },
  { k: "23", label: "Countries Served" },
  { k: "11", label: "Years of Craft" },
  { k: "$420M", label: "Client Revenue Impact" },
];

export const PROCESS = [
  { step: "01", t: "Discovery", d: "Two-week diagnostic — we interrogate your problem, users, and data before a single pixel moves." },
  { step: "02", t: "Architecture", d: "Engineering blueprint: data models, service boundaries, infra envelope, cost model." },
  { step: "03", t: "Build & Iterate", d: "Weekly ship cadence. Demos every Friday. No waterfall. No vaporware." },
  { step: "04", t: "Scale & Handover", d: "Observability, runbooks, and team enablement. We leave you sharper than we found you." },
];

export const TESTIMONIALS = [
  { q: "Shoonya shipped in 11 weeks what two US vendors couldn't finish in a year. Brutally precise.", a: "Ananya Desai", r: "CTO, VaultX" },
  { q: "They pushed back on the brief. Three times. The final product is why we're a category leader now.", a: "Marcus Lehmann", r: "VP Product, Aura Commerce" },
  { q: "The best engineering team I've worked with — anywhere. Period.", a: "Dr. Kavita R.", r: "Founder, Praana Health" },
];

export const MARQUEE = ["VaultX", "Praana Health", "Aura Commerce", "Nexus Supply", "DataNode", "CineStream", "Helion AI", "Meridian Bank", "Kavach Labs", "Orbit Mobility"];
